<template>
    <div>
        <vs-card title="Background Pick" class="p-4 mb-6">
            <div slot="header" class="flex flex-wrap items-center justify-between">
                <div class="flex items-center">
                    <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                    <h4 style="margin-left: 10px">Cancel Good Receive</h4>
                </div>
                <div class="flex items-center">
                    <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Cancel GR</vs-button>
                </div>
            </div>
            <div class="vx-row mt-6">
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="GR ID" v-model="gr_id" disabled/>
                        </div>
                    </div>
                    <div class="vx-row mb-3">
                        <div class="vx-col w-full">
                            <vs-input class="w-full" label="GR Reference" v-model="gr_reference" disabled/>
                        </div>
                    </div>
                </div>
                <div class="vx-col md:w-1/3 w-full">
                    <div class="vx-row mb-3 mt-1">
                        <div class="vx-col w-full">
                            <label for="" class="vs-input--label">Cancel GR Date *</label>
                            <flat-pickr class="w-full" v-model="arrival_date"/>
                        </div>
                    </div>
                </div>
            </div>
        </vs-card>
        <vs-card title="Item Details" class="p-4 mb-6">
                <vs-table multiple v-model="selected" :data="drafts" stripe>
                    <template slot="thead">
                        <vs-th>Line ID</vs-th>
                        <vs-th>Product ID</vs-th>
                        <vs-th>Description</vs-th>
                        <vs-th>Pack ID</vs-th>
                        <vs-th>Batch</vs-th>
                        <vs-th>Exp. Date</vs-th>
                        <vs-th>Qty</vs-th>
                        <vs-th>UoM</vs-th>
                        <vs-th>Open Qty</vs-th>
                        <vs-th>Recv Qty</vs-th>
                        <vs-th>Base Qty</vs-th>
                        <vs-th>Base Uom</vs-th>
                    </template>

                    <template slot-scope="{data}">
                        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].line_id }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].inbound_details.product.product_code }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].inbound_details.product.description_1 }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].pack_id }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].batch }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].expired_date }}
                        </vs-td>
                        
                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].qty}}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].uom.name }}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].inbound_details.open_qty}}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].inbound_details.recv_qty}}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].base_qty}}
                        </vs-td>

                        <vs-td :data="data[indextr].line_id">
                            {{ data[indextr].base_uom.name }}
                        </vs-td>


                        </vs-tr>
                    </template>
                </vs-table>
        </vs-card>
    </div>  
</template>

<script>
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

export default {
    components:{
        flatPickr,
    },
    data() {
        return {
            selected: [],
            drafts: [],
            gr_id:'',
            gr_reference: 'sss',
            arrival_date: new Date(),
            isLoading:false,
        }
    },
    watch:{
        isLoading: function(){
            if(this.isLoading){
                this.$vs.loading()
            }
            else{
                this.$vs.loading.close()
            }
        }
    },
    methods: {
        fetchData() {
            const dataSend = {
                good_receive: JSON.stringify({id:this.$route.params.id})
            }
            this.$http.get('inbound/goodreceive/'+this.$route.params.id)
            .then(res => {
                this.gr_id = this.$route.params.id;
                this.gr_reference = res.data.good_receive.gr_reference;
                res.data.good_receive_details.map(item => {
                    this.drafts.push(item)
                    // if(item.inventory_first_id) {
                    //     this.selected.push(item)
                    // }
                })
                this.isLoading = false;
            })
            .catch(error => console.log(error))

        },
        back() {
            this.$vs.dialog({
                color: 'warning',
                title: 'Leave Page',
                text: 'Changes you made may not be saved?',
                acceptText: 'Leave Page',
                accept: () => this.$router.push({ name: 'good-receive-view', params: {id: this.$route.params.id} }),
            })
        },
        submitForm() {
            let error = false
            const grHead = {
                gr_id:this.gr_id,
                inbound_reference: this.gr_reference,
                req_del_date: this.arrival_date
            }

            const details = []

            if(this.selected.length <= 0) {
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'No item selected'
                })
            }else{
                
            this.isLoading = true ;
            this.selected.map(item => {
                details.push({
                    id: item.id,
                })
            })
            
            const dataSend = {
                good_receive: JSON.stringify(grHead),
                good_receive_details: JSON.stringify(details),
            }

            this.$http.post('inbound/goodreceive/cancel', dataSend)
            .then(() => {
                this.isLoading = false
                this.$vs.notify({
                    color: 'success',
                    title: 'Success',
                    iconPack: 'feather',
                    icon:'icon-check',
                    text: 'Saved successfully'
                })
                this.$router.push({ name: 'good-receive' })
            })
            .catch(() => {
                this.isLoading = false
                this.$vs.notify({
                    color: 'danger',
                    title: 'Error',
                    iconPack: 'feather',
                    icon:'icon-x',
                    text: 'Something went wrong'
                })
            })

            }

        }
    },
    mounted() {
        this.isLoading = true;
        if(this.isLoading){
            this.$vs.loading()
        }
        this.fetchData()
    }
}
</script>